import { render } from "./AprobacionVacaciones.vue?vue&type=template&id=bfec0b98&scoped=true"
import script from "./AprobacionVacaciones.vue?vue&type=script&lang=js"
export * from "./AprobacionVacaciones.vue?vue&type=script&lang=js"

import "./AprobacionVacaciones.vue?vue&type=style&index=0&id=bfec0b98&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfec0b98"]])

export default __exports__